import { useEffect, useState } from "react";
import { fetchNotificationUsersEndPoint } from "../../configuration";
import { useSelector } from "react-redux";
import CustomHOCTable from "../../global/components/Tables/CustomHOCTable";
import { Body, Title } from "@vds/typography";
import { Button, TextLink } from "@vds/buttons";
import { Icon } from "@vds/icons";
import axiosInstance from "../../global/axiosInterceptor";
import { BUTTON_TEXT } from "../../global/constants/constants";
import moment from "moment-timezone";
import { getDateforUsers } from "../../global/utility/Utils";

const UsersTab = () => {
  const [usersList, setUsersList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [usersDataSource, setUsersDataSource] = useState(null);
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );

  const columns = [
    {
      title: (
        <Title size="small" bold primitive="h2" viewport="desktop">
          User
        </Title>
      ),
      dataIndex: "User",
      key: "User",
      render: (text, record) => {
        return (
          <TextLink
            type="standAlone"
            size="large"
            className="link users-table-user-link"
            style={{
              marginLeft: "10px",
              whiteSpace: "nowrap",
              display: "block",
              borderBottomStyle: "none",
              overflow: "hidden",
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            <Body size="large" viewport="desktop" primitive="span">
              {text}
            </Body>
          </TextLink>
        );
      },
    },
    {
      title: (
        <Title size="small" bold primitive="h2" viewport="desktop">
          Site
        </Title>
      ),
      dataIndex: "Site",
      key: "Site",
    },
    {
      title: (
        <Title size="small" bold primitive="h2" viewport="desktop">
          Role
        </Title>
      ),
      dataIndex: "Role",
      key: "Role",
    },
    {
      title: (
        <Title size="small" bold primitive="h2" viewport="desktop">
          Date Added
        </Title>
      ),
      dataIndex: "DateAdded",
      key: "DateAdded",
    },
    {
      title: (
        <Title size="small" bold primitive="h2" viewport="desktop">
          Actions
        </Title>
      ),
      dataIndex: "Actions",
      key: "Actions",
      render: (text, record) => {
        return {
          children: (
            <div style={{ display: "flex", gap: "10px" }}>
              <div style={{ cursor: "pointer" }}>
                <Icon name="trash" size="medium" color="#000000" />
              </div>
            </div>
          ),
        };
      },
    },
  ];

  useEffect(() => {
    const fetchNotificationUser = async () => {
      const response = await axiosInstance.post(
        fetchNotificationUsersEndPoint(),
        {
            accountName: activeSession.accountId,
        }
      );
      const userResponse = response.data;
      setUsersList(userResponse);
    };
    fetchNotificationUser();
  }, []);

  const getSiteDetails = (userItem) => {
    const siteNames =
      userItem?.tags && userItem?.tags?.length > 1
        ? `Multiple Sites (${userItem.tags.length})`
        : userItem?.tags?.length === 1
        ? userItem?.tags[0]?.name
        : "Not Available";
    return siteNames;
  };

  const getUsersDataSource = (usersList) => {
    return usersList?.map((userItem) => ({
      User: userItem?.firstname + userItem?.lastname,
      Site: getSiteDetails(userItem),
      Role: "NA",
      DateAdded: userItem?.createdon ? getDateforUsers(userItem) : "",
      Actions: "",
    }));
  };

  const getUsersTableData = () => {
    let usersData = getUsersDataSource(usersList);
    setUsersDataSource(usersData);
  };

  useEffect(() => {
    setLoading(true);
    getUsersTableData();
    setLoading(false);
  }, [usersList]);

  const UsersTable = CustomHOCTable();

  const InviteUserButton = (
    <Button
      size="medium"
      use="primary"
    >
      {BUTTON_TEXT.INVITE_USER}
    </Button>
  );

  return (
    <>
      <UsersTable
        showSearch={true}
        dataList={usersDataSource}
        columns={columns}
        loading={loading}
        extraAction={InviteUserButton}
      />
    </>
  );
};

export default UsersTab;
